import { LLMTemplateDetailsContainer } from '@/modules/LLMTemplateDetails';

export const LLMTemplateDetails = (): JSX.Element => <LLMTemplateDetailsContainer />;

export default LLMTemplateDetails;
